import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import RadioButton from '../radioButton'

export interface Option {
  label: string
  value: string
  checked: boolean
}

export interface Props {
  options: Option[] | null
  name: string
  onChange(value: string): void
}

const ToggleBoxField: FunctionComponent<Props> = ({
  options,
  name,
  onChange,
}) => {
  return (
    <div className="form__group">
      <div>
        {options &&
          options.map((option) => {
            const { label, value, checked } = option
            return (
              <div
                className={classnames('form__checkbox-container', {
                  'form__checkbox-container--selected': checked,
                })}
                key={value}
                onClick={() => onChange(value)}
              >
                <label htmlFor={value} className="coverage__label-text">
                  {label}
                </label>
                <RadioButton
                  iconSize="20px"
                  name={name}
                  uid={value}
                  checked={checked}
                  value={value}
                  onChange={() => onChange(value)}
                />
              </div>
            )
          })}
      </div>
    </div>
  )
}

ToggleBoxField.displayName = 'ToggleBoxField'

export default ToggleBoxField
